import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import './ClassicExchEvents.scss';
import { Accordion, AccordionDetails, AccordionSummary, Paper, Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material';
import MarketOddBtn from '../MarketOddBtn/marketOddBtn';
import { RootState } from '../../models/RootState';
import { setExchSelectedSport } from '../../store/exchangeSports/exchangeSportsReducer';
import { fetchSports, listExchEvents, listLiveExchEvents } from '../../store/exchangeSports/exchangeSportsAction';
import Inplay from '../../assets/sports/inplay.gif'
import { sportsIconMap, sportNamesMap } from '../../constants/sports'
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import ExpandLessSharp from '@mui/icons-material/ExpandLessSharp';
import { dispatch } from '../../store/store';
import Loader from "../../assets/images/Strike_White_Logo_Transparent_GIF.gif";
import { TopicUrls } from '../../models/EventData';
import { checkStompClientSubscriptions, disconnectToWS, subscribeForMatchOdds } from '../../websockets/webSocket';

type StoreProps = {
    sports: any;
    exchSelectedSport: string;
    setExchSelectedSport: (data: string) => void;
    listExchEvents: (inplay: boolean, sportId: string) => void;
    exchEvents: any;
    listLiveExchEvents: () => void;
    topicUrls?: TopicUrls;
    betFairWSConnected: boolean;
};

export const EmptyOddsBlock = React.memo(() => {
    return (
        <React.Fragment>
            <MarketOddBtn mainValue={null} oddType="back-odd" disable={true} />
            <MarketOddBtn mainValue={null} oddType="lay-odd" disable={true} />
        </React.Fragment>
    );
});

const ClassicExchEvents: React.FC<StoreProps> = (props) => {
    const { sports, exchSelectedSport, setExchSelectedSport, listExchEvents, exchEvents, listLiveExchEvents, topicUrls, betFairWSConnected } = props;
    const LIVE = "LIVE";
    const teamTypes = [0, 2, 1];
    const customGroupOrder = ["LIVE", "LIVE-4", "LIVE-1", "LIVE-2", "UPCOMING"];
    const customOrder = ["4", "1", "2"];
    const [sortedEvents, setSortedEvents] = useState<any>();
    const [sortedSports, setSortedSports] = useState<any>();
    const navigate = useNavigate();
    const [loading, setLoading] = useState<boolean>(false);

    const getOdds = (eventData: any, teamIndex: number) => {
        if (!eventData?.markets?.matchOdds?.[0]?.runners?.[teamIndex]) {
            return null;
        }

        const runner = eventData?.markets?.matchOdds?.[0]?.runners[teamIndex];
        return [
            {
                type: 'back-odd',
                price: runner?.backPrices[0]?.price,
                size: runner.backPrices[0]?.size,
                outcomeId: runner?.runnerId,
                outcomeName: runner.runnerName,
            },
            {
                type: 'lay-odd',
                price: runner?.layPrices[0]?.price,
                size: runner?.layPrices[0]?.size,
                outcomeId: runner.runnerId,
                outcomeName: runner.runnerName,
            },
        ];
    };

    useEffect(() => {
        const init = async () => {
            if (sports && sports.length > 0) {
                const sortedSports = [...sports].sort((a, b) => {
                    const indexA = customOrder.indexOf(a.sportId?.toString());
                    const indexB = customOrder.indexOf(b.sportId?.toString());

                    if (indexA === -1 && indexB === -1) return 0;
                    if (indexA === -1) return 1;
                    if (indexB === -1) return -1;

                    return indexA - indexB;
                });
                setSortedSports(sortedSports);
                if (!exchSelectedSport) {
                    setExchSelectedSport(LIVE);
                }
            } else {
                setLoading(true);
                await dispatch(fetchSports("EX123"));
                setLoading(false);
            }
        };
        init();

    }, [sports]);

    useEffect(() => {
        if (exchSelectedSport === LIVE) {
            listLiveExchEvents();
        } else if (exchSelectedSport) {
            listExchEvents(true, exchSelectedSport);
            listExchEvents(false, exchSelectedSport);
        }
    }, [exchSelectedSport]);

    useEffect(() => {
        if (topicUrls?.matchOddsBaseUrl) {
            const baseUrlsPayload = {
                matchOddsBaseUrl: topicUrls?.matchOddsBaseUrl,
                bookMakerAndFancyBaseUrl: null,
                premiumBaseUrl: null,
            };
            checkStompClientSubscriptions(baseUrlsPayload);
        }
    }, [topicUrls]);

    useEffect(() => {
        return () => {
            disconnectToWS();
        };
    }, []);

    useEffect(() => {
        if (!betFairWSConnected || !topicUrls?.matchOddsTopic) return;

        const newSubscriptions = new Set();
        Object.entries(exchEvents || {}).forEach(([sportKey, eventMap]) => {
            Object.values(eventMap || {}).forEach((event: any) => {
                const shouldSubscribe =
                    event?.status === 'IN_PLAY' &&
                    event?.markets?.matchOddsProvider === 'BetFair' &&
                    !newSubscriptions.has(event.eventId) &&
                    event?.markets?.matchOdds?.length > 0 &&
                    event?.markets?.matchOdds?.[0]?.marketId;

                if (shouldSubscribe) {
                    newSubscriptions.add(event.eventId);
                    subscribeForMatchOdds(
                        topicUrls.matchOddsTopic,
                        sportKey,
                        event?.eventId,
                        event?.markets?.matchOdds?.[0]?.marketId
                    );
                }
            });
        });
    }, [exchEvents, betFairWSConnected]);

    useEffect(() => {
        const validEntries = Object.entries(exchEvents).filter(
            ([, eventMap]) => eventMap && typeof eventMap === 'object' && Object.keys(eventMap).length > 0
        );

        const sortedEntries = validEntries.sort(([keyA], [keyB]) => {
            const indexA = customGroupOrder.indexOf(keyA);
            const indexB = customGroupOrder.indexOf(keyB);

            if (indexA !== -1 && indexB !== -1) return indexA - indexB;
            if (indexA !== -1) return -1;
            if (indexB !== -1) return 1;

            return keyA.localeCompare(keyB);
        });
        setSortedEvents(sortedEntries);
    }, [exchEvents]);

    const handleEventClick = (eventDto: any) => {
        navigate(`/markets/${btoa(eventDto?.sportId + "|" + eventDto?.competitionId + "|" + eventDto?.eventId)}`);
    };

    return (
        <>
            {
                loading ? (
                    <div className="home-loading">
                        <img src={Loader} style={{ height: '10rem' }} />
                    </div>

                ) : (
                    <>
                        <div className="exch-sports-tabs-ctn">
                            <div className="exch-sports-tabs">
                                <div className="exch-sport-tabs">
                                    <button
                                        className={`exch-tab ${exchSelectedSport === LIVE
                                            ? 'exch-selected-tab'
                                            : ''
                                            }`}
                                        onClick={() => {
                                            setExchSelectedSport(LIVE);
                                        }}
                                    >
                                        <img src={Inplay} className="exch-sub-header-icons" style={{ margin: "-6px 0px 0px 4px", height: "25px", width: "50px" }} />

                                    </button>
                                    {sortedSports?.map(
                                        (sport: any) =>
                                            <button
                                                key={sport?.sportId}
                                                className={`exch-tab ${exchSelectedSport === sport?.sportId
                                                    ? 'exch-selected-tab'
                                                    : ''
                                                    }`}
                                                onClick={() => {
                                                    setExchSelectedSport(sport?.sportId);
                                                }}
                                            >
                                                <img src={sportsIconMap[sport?.sportId]} className="exch-sub-header-icons" />
                                                {sport.sportName}
                                            </button>
                                    )}
                                </div>
                            </div>
                        </div>

                        <div className="exch-events-table-ctn">
                            {sortedEvents?.length ? (
                                (sortedEvents ?? [])?.map(([sportId, events]: [string, any[]]) => (
                                    <>
                                        <Accordion
                                            className="exch-eventtype-accordion"
                                            defaultExpanded={true}
                                            key={sportId}
                                        >
                                            <AccordionSummary
                                                expandIcon={
                                                    <ExpandLessSharp className="expand-icon" />
                                                }
                                                aria-controls="panel1a-content"
                                            >
                                                <TableRow
                                                    className="acc-head"
                                                >
                                                    <TableCell
                                                        colSpan={3}
                                                        className="acc-cell"
                                                    >
                                                        <div className="exch-icon-and-name">
                                                            <img src={sportsIconMap[sportId.includes("-") ? sportId.split("-")[1] : sportId]} />
                                                            <div className="exch-event-name">
                                                                {
                                                                    sportNamesMap[sportId.includes("-") ? sportId.split("-")[1] : sportId]
                                                                }{' '}
                                                            </div>
                                                        </div>
                                                    </TableCell>
                                                </TableRow>
                                            </AccordionSummary>
                                            <AccordionDetails className="exch-events-tbl-container">
                                                <div className="exch-events-table-content table-ctn">
                                                    <TableContainer component={Paper}>
                                                        <Table className="exch-events-table exch-inplay-table">
                                                            <TableBody>
                                                                {Object.values(events || {}).map((event: any, idx: any) => (
                                                                    <TableRow
                                                                        key={idx}
                                                                        onClick={() =>
                                                                            handleEventClick(event)
                                                                        }
                                                                        className="exch-bgc-white"
                                                                    >
                                                                        <TableCell
                                                                            className="exch-teams-cell exch-et-b-c"
                                                                            colSpan={8}
                                                                        >
                                                                            <div
                                                                                className="all-markets-nav-link"
                                                                                key={idx + 'all-markets-link'}
                                                                            >
                                                                                <div className="exch-team-name">
                                                                                    <div className="exch-home-away-team">
                                                                                        <div className="exch-team-names">{event?.eventName}</div>

                                                                                        <div className="exch-team-names exch-flex-team">
                                                                                            <span className="exch-date">
                                                                                                {'(' + moment(event?.openDate).format('DD/MM/YY , hh:mm A') + ')'}
                                                                                            </span>
                                                                                            {event?.status == 'IN_PLAY' && (
                                                                                                <img
                                                                                                    className={'exch-live-img-display'}
                                                                                                    src={Inplay}
                                                                                                />
                                                                                            )}
                                                                                            {event?.status === 'UPCOMING' && (
                                                                                                <div className="exch-upcoming-badge">Upcoming</div>
                                                                                            )}
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="enabled-markets">

                                                                                        {event?.catId === 'SR VIRTUAL' &&
                                                                                            <div className="market-enabled-inner">
                                                                                                {'V'}
                                                                                            </div>}

                                                                                        {event?.premiumEnabled && event?.catId !== 'SR VIRTUAL' &&
                                                                                            <div className="market-enabled-inner">
                                                                                                {'P'}
                                                                                            </div>}
                                                                                        {event?.markets?.matchOdds?.length > 0 &&
                                                                                            <div className="market-enabled-inner">
                                                                                                {'MO'}
                                                                                            </div>}
                                                                                        {event?.markets?.bookmakers?.length > 0 &&
                                                                                            <div className="market-enabled-inner">
                                                                                                {'BM'}
                                                                                            </div>}
                                                                                        {event?.markets?.fancyMarkets?.length > 0 &&
                                                                                            <div className="market-enabled-inner">
                                                                                                {'F'}
                                                                                            </div>}
                                                                                    </div>
                                                                                </div>

                                                                                {(
                                                                                    <div className="mob-odds-row new-odds-row">
                                                                                        {teamTypes.map((teamType, index) => (
                                                                                            <div
                                                                                                className="mob-odds-block"
                                                                                                key={index}
                                                                                            >
                                                                                                <div className="mob-exchange-btn-odd-row">
                                                                                                    {event?.markets?.matchOdds ? (
                                                                                                        getOdds(event, teamType) ? (
                                                                                                            <>
                                                                                                                {getOdds(
                                                                                                                    event,
                                                                                                                    teamType
                                                                                                                )?.map((odd: any, index: any) => (
                                                                                                                    <MarketOddBtn
                                                                                                                        key={index}
                                                                                                                        mainValue={odd.price}
                                                                                                                        subValue={odd.size}
                                                                                                                        oddType={odd.type}
                                                                                                                        disable={event?.markets?.matchOdds?.[0]?.status
                                                                                                                            .toLowerCase()
                                                                                                                            .includes(
                                                                                                                                'suspended'
                                                                                                                            )}
                                                                                                                        valueType={
                                                                                                                            'matchOdds'
                                                                                                                        }
                                                                                                                        showSubValueinKformat={
                                                                                                                            true
                                                                                                                        }
                                                                                                                    />
                                                                                                                ))}
                                                                                                            </>
                                                                                                        ) : (
                                                                                                            <EmptyOddsBlock />
                                                                                                        )
                                                                                                    ) : (
                                                                                                        <EmptyOddsBlock />
                                                                                                    )}
                                                                                                </div>
                                                                                            </div>
                                                                                        ))}
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                        </TableCell>
                                                                    </TableRow>
                                                                ))}
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                </div>
                                            </AccordionDetails>
                                        </Accordion>
                                    </>
                                ))
                            ) :
                                <div className="events-table-msg-text">
                                    {'No Events'}
                                </div>
                            }
                        </div>
                    </>
                )
            }
        </>
    );
};

const mapStateToProps = (state: RootState) => {
    return {
        sports: state.exchangeSports.exchSports,
        exchSelectedSport: state.exchangeSports.exchSelectedSport,
        exchEvents: state.exchangeSports.exchEvents,
        topicUrls: state?.exchangeSports?.topicUrls,
        betFairWSConnected: state?.exchangeSports?.betFairWSConnected,
    };
};

const mapDispatchToProps = (dispatch: Function) => {
    return {
        setExchSelectedSport: (data: string) => dispatch(setExchSelectedSport(data)),
        listExchEvents: (inplay: boolean, sportId: string) => dispatch(listExchEvents(inplay, sportId)),
        listLiveExchEvents: () => dispatch(listLiveExchEvents()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ClassicExchEvents);
